import { render, staticRenderFns } from "./communityDataToHuishLife.vue?vue&type=template&id=16a4f8da"
import script from "./communityDataToHuishLife.vue?vue&type=script&lang=js"
export * from "./communityDataToHuishLife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports